import React from 'react';
import PropTypes from 'prop-types';
import isUndefined from 'lodash/isUndefined';

import SportsSelectionViewContainer from './../../../../../shared/components/react/SportsSelectionView/SportsSelectionViewContainer';

const SingleBetCard = (props) => {

    return (
        <SportsSelectionViewContainer
            selection={props.selection}
            commonDataEvents={props.commonDataEvents}
            errorHandler={(!isUndefined(props.errorHandler)) ? props.errorHandler : undefined}
            gtmAttribute={props.gtmAttribute}
            />
    );
};

SingleBetCard.propTypes = {
    commonDataEvents: PropTypes.object.isRequired,
    selection: PropTypes.object,
    errorHandler: PropTypes.func,
    gtmAttribute: PropTypes.string,
};

SingleBetCard.defaultProps = {
    gtmAttribute: '',
};

export default SingleBetCard;
